<template>
	<div class="phantom-container">
		<notifications group="default" />
		<router-view></router-view>
		<loader></loader>
	</div>
</template>

<script>
	export default {
    name: 'app',
    watch: {
      isAuthenticated (isAuthenticated) {
        if (!this.isAuthenticated) {
          this.$router.push({name: 'Login'})
        }
      }
    },
    computed: {
      isAuthenticated () {
        return this.$store.getters.isAuthenticated
      }
    }
	}
</script>

<style lang="scss">
	@import '~@/common/assets/sass/common.scss';
	@import '~@/assets/sass/master.scss';
</style>



// WEBPACK FOOTER //
// App.vue?76b36cc2